<ng-container *ngIf="template && previewUrl">
  <ng-container *ngTemplateOutlet="template; context: {$implicit : previewUrl}"></ng-container>
</ng-container>